var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"em-breve"},[_c('img',{attrs:{"src":require("@/assets/images/error/empty.svg")}}),_c('h4',[_vm._v("Nenhuma página encontrada")])])
}]

export { render, staticRenderFns }